// src/components/auth/SocialButtons.jsx
import { Button } from '@/components/ui/button'
import { Facebook, Apple } from 'lucide-react'
import { useEffect } from 'react';

const BACKEND_URL = import.meta.env.VITE_LARAVEL_API_URL;

const GoogleIconWhite = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" fill="white" xmlns="http://www.w3.org/2000/svg">
    <path d="M21.35 11.1H12v2.98h5.37c-.23 1.26-.93 2.33-1.98 3.05v2.53h3.2c1.87-1.72 2.96-4.25 2.96-7.16 0-.6-.05-1.18-.2-1.75z"/>
    <path d="M12 22c2.7 0 4.96-.9 6.61-2.44l-3.2-2.53c-.89.6-2.02.96-3.41.96-2.62 0-4.83-1.77-5.62-4.15H3.08v2.6C4.72 19.98 8.08 22 12 22z"/>
    <path d="M6.38 13.84A5.99 5.99 0 016 12c0-.64.11-1.25.3-1.84v-2.6H3.08A9.99 9.99 0 002 12c0 1.64.39 3.2 1.08 4.44l3.3-2.6z"/>
    <path d="M12 5.98c1.47 0 2.8.51 3.84 1.5l2.88-2.88C16.95 2.9 14.7 2 12 2 8.08 2 4.72 4.02 3.08 7.56l3.3 2.6C7.17 7.75 9.38 5.98 12 5.98z"/>
  </svg>
);

const SocialButtons = ({ onSocialClick }) => {
  const handleSocialLogin = (provider) => {
    window.location.href = `${BACKEND_URL}/auth/${provider}/redirect`;
  };

  useEffect(() => {
    if (window.FB) return;
    window.fbAsyncInit = function() {
      FB.init({
        appId: import.meta.env.VITE_FACEBOOK_APP_ID,
        cookie: true,
        xfbml: true,
        version: 'v18.0'
      });
    };
    const script = document.createElement('script');
    script.src = 'https://connect.facebook.net/en_US/sdk.js';
    script.async = true;
    script.defer = true;
    document.body.appendChild(script);
  }, []);

  return (
    <div className="flex flex-row flex-wrap justify-center gap-2">
      <Button
        className="flex-1 min-w-0 gap-1 text-white border-none bg-gradient-to-r from-[#FBBC05] to-[#EA4335] hover:opacity-90"
        onClick={() => handleSocialLogin('google')}
      >
        <GoogleIconWhite className="h-5 w-5" />
        <span className="hidden sm:inline">جوجل</span>
      </Button>

      <Button
        variant="outline"
        className="flex-1 min-w-0 gap-1 !bg-[#1877F2] text-white border-none hover:!bg-[#1877F2]/90"
        onClick={() => handleSocialLogin('facebook')}
      >
        <Facebook className="h-5 w-5" />
        <span className="hidden sm:inline">فيسبوك</span>
      </Button>

      <Button
        variant="outline"
        className="flex-1 min-w-0 gap-1 bg-black text-white border-none hover:bg-black/80 dark:bg-white dark:text-black dark:hover:bg-white/80"
        onClick={() => onSocialClick('Apple')}
      >
        <Apple className="h-5 w-5" />
        <span className="hidden sm:inline">آبل</span>
      </Button>
    </div>
  );
};

export default SocialButtons;